/**
 * Created by calhosh on 12/22/2022
 */
import React from 'react';
import styled from 'styled-components';
import Tooltip from '../BaseComponentWrappers/MotifTooltip';
import IconButton from '../BaseComponentWrappers/MotifIconButton';
import {SVGICONS} from '@ey/icons';

export default function TimeTrackerPlaceholder(props) {
	const {placeholderMessage, mode} = props;

	return (
		<StyledSectionWrapper className="timetracking-main-wrap-error">
			<Tooltip
				className={'timetracking-tooltip-placeholer'}
				variant="alt"
				allowHover={false}
				hideCloseButton
				placement="left"
				trigger={
					<IconButton
						className={'clock-available'}
						aria-label="Tooltip"
						type="button"
						onClick={() => {}}
						disabled
						title={'Time-Tracking'}
					>
						<SVGICONS styleName="medium" hoverText={'Time-tracking'} name={'clock-available'} />
					</IconButton>
				}
			>
				<StyledErrorSection className="">{placeholderMessage}</StyledErrorSection>
			</Tooltip>
		</StyledSectionWrapper>
	);
}

const StyledErrorSection = styled.section`
	padding: var(--px-15) !important;
	font-size: var(--px-12);
	display: flex;
	align-items: center;
	height: 100%;
`;

const StyledSectionWrapper = styled.section`
	position: absolute;
	bottom: var(--px-10);
	right: 0;
	z-index: 9;
	.clock-available {
		width: var(--px-35);
		height: var(--px-35);
		border-radius: var(--px-4);
		svg {
			width: var(--px-25);
			height: var(--px-25);
			max-width: var(--px-25);
			max-height: var(--px-25);
		}
		&:hover,
		&:focus {
			svg {
				background: transparent;
			}
		}
		&[disabled] {
			svg {
				path {
					fill: var(--neutrals-100) !important;
				}
			}
		}
	}
	.clock-available {
		width: var(--px-35) !important;
		height: var(--px-35) !important;
		border-radius: var(--px-4);
		display: flex !important;
		align-items: center;
		justify-content: center;
		background: var(--neutrals-300) !important;
		svg {
			width: var(--px-25);
			height: var(--px-25);
			max-width: var(--px-25);
			max-height: var(--px-25);
		}
		&:hover,
		&:focus {
			svg {
				background: transparent;
			}
		}
	}
	.timetracking-main-wrap-error {
		width: 82%;
		display: flex;
		flex-direction: column;
		margin-left: var(--px-5);
		font-size: var(--px-12);
	}
`;
